import clsx from "clsx";

import { ButtonAnchor } from "@/components/Interface/Button/Button";
import { Notification } from "@/components/Interface/Notification/Notification";

import { KYCPrepInstructions } from "./KYCPrepInstructions";

type ExternalButtonLinkProps = {
  href?: string;
  label?: string;
  disabled?: boolean;
  className?: string;
};

/**
 * External CTA styled as a design-system button. Plain (not inverted) primary:
 * the card it sits on is ivory, where the inverted variant renders white on
 * white.
 */
const ExternalButtonLink = ({
  href,
  label = "",
  disabled = false,
  className,
}: ExternalButtonLinkProps) => (
  <div className={clsx("inline-flex", className)}>
    <ButtonAnchor
      className="whitespace-nowrap tablet:w-fit"
      disabled={disabled}
      fullWidth
      href={href}
      variant="primary"
    >
      {label}
    </ButtonAnchor>
  </div>
);

type IDCheckComponentProps = {
  title: string;
  info: string;
  warningInfo?: string;
  buttonLabel: string;
  target?: string;
};

export const WarningWithKYCButton = ({
  title,
  info,
  warningInfo,
  buttonLabel,
  target,
}: IDCheckComponentProps) => (
  <div className="flex w-full flex-col gap-6">
    <div className="flex w-full flex-col gap-4">
      <h1 className="text-headline-xl font-semibold leading-xs text-foreground-primary">
        {title}
      </h1>
      {info ? (
        <p className="text-body-sm leading-md text-foreground-secondary">
          {info}
        </p>
      ) : null}
    </div>

    <KYCPrepInstructions />
    {warningInfo ? (
      <Notification tone="warning" description={warningInfo} />
    ) : null}
    {/* Right-aligned from tablet up, full width on mobile - the button
        wraps its own anchor, so the alignment comes from this parent. */}
    <div className="flex flex-col tablet:items-end">
      <ExternalButtonLink
        className="w-full tablet:w-auto"
        disabled={target === undefined}
        href={target}
        label={buttonLabel}
      />
    </div>
  </div>
);
